import globalStore from "/globalStore.js";

//-- Visibility rules for the Administration sections, shared by the admin side nav
//-- (primary-navigation-setup.js), the Administration menu link and the Administration
//-- landing page (admin/index.vue), so a section hidden in one is hidden in the others.

//-- Release toggles: flip a section on once it's tested and ready to ship.
//-- "Available for all" sections are still gated by the toggle; permission-gated
//-- sections also require the listed feature access.
const sectionEnabled = {
	people: true,
	clientsAndBuckets: true,
	clientsAndBucketsTaskTemplates: true,
	crmAndSales: true,
	mobile: false,
	rostering: false,
	financials: true,
	reporting: true,
	devices: false,
	ai: false,
	integrations: false,
	orgSettings: true,
	auditLog: false,
};

//-- Sections still under development are shown only to Lotus staff.
const lotusStaffOnly = {
	clientsAndBucketsTaskTemplates: true,
	financials: true,
	orgSettings: true,
};

//-- Who may see a section. Every section needs Account Admin > All, except those listed here, which have their own rule.
//-- CRM & Sales is open to the CRM's own administrators (Admin > All actions) as well as account admins, and needs the
//-- account's CRM licence. Not the module switch: an administrator has to reach the switch to turn it on.
const sectionAccess = {
	crmAndSales: () => hasAccess("CRM.Enabled") && (hasAccess("CRM.AdminSectionAll") || isAccountAdmin() || isLotusStaff()),
};


function hasAccess(featureCode)
{
	if (!globalStore.currentUser) return false;
	return globalStore.currentUser.hasFeatureAccess(featureCode);
}


function isLotusStaff()
{
	return hasAccess("LotusAdministration.All") || hasAccess("LotusDevelopment.All");
}


function isAccountAdmin()
{
	return hasAccess("AccountAdmin.All");
}


export function isAdminSectionVisible(sectionKey)
{
	if (!sectionEnabled[sectionKey]) return false;
	if (lotusStaffOnly[sectionKey] && !isLotusStaff()) return false;

	const access = sectionAccess[sectionKey];
	return access ? access() : isAccountAdmin();
}


//-- The Administration menu link: shown when the person can see at least one section.
export function canOpenAdministration()
{
	return Object.keys(sectionEnabled).some((sectionKey) => isAdminSectionVisible(sectionKey));
}
